import { React, useState, useRef } from "react";
// import "./LLPRegistration.css";
import "./PrivateLimitedCompany.css";
import ContactPopup from "./ContactPopup";

const LLPRegistration = () => {
  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>Limited Liability Partnership (LLP)</h1>

        <p className="subtitle">
          Start Your LLP Easily & Secure Your Business
        </p>

        <p className="desc">
          Flexible Structure with Limited Liability Protection. We help startups, professionals, and small businesses register their LLP quickly and compliantly. Enjoy the benefits of a partnership with the protection of a company—without complex compliance.
        </p>

        <div className="badges">
          <span>✔ Quick Online Registration</span>
          <span>✔ Expert Legal Assistance</span>
          <span>✔ Affordable Packages</span>
          <span>✔ End-to-End Support</span>
        </div>

        <div className="hero-action">
          <button className="hero-btn" onClick={scrollToContact} >
            Get Started Today
          </button>
        </div>

      </div>

      {/* WHAT IS LLP */}
      <div className="section">
        <h2>What is a Limited Liability Partnership (LLP)?</h2>
        <p>
          A Limited Liability Partnership (LLP) is a hybrid business structure that combines the flexibility of a partnership with the benefits of limited liability. It is governed by the LLP Act, 2008 in India.
        </p>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of LLP</h2>
        <ul>
          <li>Limited liability for partners</li>
          <li>Separate legal identity</li>
          <li>Lower compliance compared to companies</li>
          <li>No minimum capital requirement</li>
          <li>Flexible management structure</li>
          <li>Suitable for professionals & SMEs</li>
        </ul>
      </div>

      {/* SERVICES */}
      <div className="section">
        <h2>Our LLP Registration Services Include</h2>
        <ul>
          <li>Digital Signature Certificate (DSC)</li>
          <li>DPIN / DIN Application</li>
          <li>Name Reservation (RUN-LLP)</li>
          <li>LLP Agreement Drafting</li>
          <li>Incorporation Filing</li>
          <li>Certificate of Incorporation</li>
          <li>PAN & TAN Application</li>
          <li>Bank Account Assistance</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>

        <h3>For Partners:</h3>
        <ul>
          <li>PAN Card</li>
          <li>Aadhaar / Passport / Voter ID</li>
          <li>Passport-size Photograph</li>
          <li>Address Proof (Bank Statement / Utility Bill)</li>
        </ul>

        <h3>For Registered Office:</h3>
        <ul>
          <li>Rent Agreement (if rented)</li>
          <li>NOC from Owner</li>
          <li>Utility Bill</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>Simple Registration Process</h2>
        <ul>
          <li>Consultation – Share business details</li>
          <li>Document Submission – Provide documents</li>
          <li>Name Approval – Reserve LLP name</li>
          <li>Filing Process – Legal filings handled by us</li>
          <li>Approval – Get LLP certificate</li>
        </ul>
      </div>

      {/* PRICING */}
      <div className="section">
        <h2>Pricing Plans</h2>

        <div className="grid">

          <div className="card blue">
            <h3>Basic Plan</h3>
            <ul>
              <li>LLP Registration</li>
              <li>DSC for 2 Partners</li>
              <li>PAN Application</li>
            </ul>
          </div>

          <div className="card purple">
            <h3>Standard Plan</h3>
            <ul>
              <li>Everything in Basic</li>
              <li>LLP Agreement Drafting</li>
              <li>Bank Account Assistance</li>
            </ul>
          </div>

          <div className="card orange">
            <h3>Premium Plan</h3>
            <ul>
              <li>Everything in Standard</li>
              <li>GST Registration</li>
              <li>Compliance Support</li>
            </ul>
          </div>

        </div>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Experienced Legal Experts</li>
          <li>Fast & Reliable Service</li>
          <li>Transparent Pricing</li>
          <li>Dedicated Support</li>
          <li>100% Online Process</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>How many partners required?</b> Minimum 2 partners required.</p>
        <p><b>Is LLP better than partnership?</b> Yes, it provides limited liability protection.</p>
        <p><b>Time for registration?</b> 5–10 working days.</p>
        <p><b>Audit required?</b> Only if turnover exceeds limits.</p>
      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef}>
        <h2>Ready to Register Your LLP?</h2>
        <p>Get started with expert support today.</p>

        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
        </div>
      </div>

    </div>
  );
};

export default LLPRegistration;